import { render } from "./version-update-badge.vue?vue&type=template&id=679324e4&scoped=true"
import script from "./version-update-badge.vue?vue&type=script&lang=js"
export * from "./version-update-badge.vue?vue&type=script&lang=js"

import "./version-update-badge.vue?vue&type=style&index=0&id=679324e4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3625838732/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679324e4"]])

export default __exports__